"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = exports.setMinLogLevel = exports.initLogger = void 0;
const pino = require("pino");
const LogEntry_1 = require("./DataModels/LogEntry");
let minimumLogLevel;
let engineId;
let hostname;
// Taken from: https://stackoverflow.com/questions/17575790/environment-detection-node-js-or-browser/31090240#31090240
const isBrowserEnv = new Function('try {return this===window;}catch(e){ return false;}')();
const logger = isBrowserEnv
    ? getPinoInstanceForBrowser()
    : getPinoInstanceForNode();
function getPinoInstanceForBrowser() {
    return pino({
        base: {},
        level: LogEntry_1.LogLevel.debug,
        timestamp: pino.stdTimeFunctions.isoTime,
        browser: {
            asObject: true,
        },
    });
}
function getPinoInstanceForNode() {
    let pinoDestination;
    if (typeof pino.destination === 'function') {
        try {
            pinoDestination = pino.destination({ sync: false });
        }
        catch { }
    }
    return pino({
        base: {},
        level: LogEntry_1.LogLevel.debug,
        timestamp: pino.stdTimeFunctions.isoTime,
    }, pinoDestination);
}
function initLogger(settings) {
    setMinLogLevel(settings.minLogLevel);
    engineId = settings.engineId;
    hostname = settings.hostname || process.env.hostname;
}
exports.initLogger = initLogger;
function setMinLogLevel(minLogLevelToSet) {
    if (minLogLevelToSet && LogEntry_1.LogLevel[minLogLevelToSet.toLowerCase()] !== undefined) {
        minimumLogLevel = minLogLevelToSet;
    }
    else {
        logger.error(`Unknown LogLevel "${minLogLevelToSet}".`);
    }
}
exports.setMinLogLevel = setMinLogLevel;
class Logger {
    constructor(namespace, defaultLogObject) {
        this.namespace = namespace;
        this.defaultLogObject = defaultLogObject !== null && defaultLogObject !== void 0 ? defaultLogObject : {};
    }
    addToDefaultLogObject(key, value) {
        this.defaultLogObject[key] = value;
    }
    removeFromDefaultLogObject(key) {
        delete this.defaultLogObject[key];
    }
    error(message, logObject) {
        if (!this.shouldLog(LogEntry_1.LogLevel.error)) {
            return;
        }
        const logObjectWithDefaults = Object.assign({}, this.defaultLogObject, logObject);
        log(LogEntry_1.LogLevel.error, this.namespace, message, logObjectWithDefaults);
    }
    warn(message, logObject) {
        if (!this.shouldLog(LogEntry_1.LogLevel.warn)) {
            return;
        }
        const logObjectWithDefaults = Object.assign({}, this.defaultLogObject, logObject);
        log(LogEntry_1.LogLevel.warn, this.namespace, message, logObjectWithDefaults);
    }
    info(message, logObject) {
        if (!this.shouldLog(LogEntry_1.LogLevel.info)) {
            return;
        }
        const logObjectWithDefaults = Object.assign({}, this.defaultLogObject, logObject);
        log(LogEntry_1.LogLevel.info, this.namespace, message, logObjectWithDefaults);
    }
    debug(message, logObject) {
        if (!this.shouldLog(LogEntry_1.LogLevel.debug)) {
            return;
        }
        const logObjectWithDefaults = Object.assign({}, this.defaultLogObject, logObject);
        log(LogEntry_1.LogLevel.debug, this.namespace, message, logObjectWithDefaults);
    }
    shouldLog(logLevel) {
        if (!minimumLogLevel) {
            return true;
        }
        return this.logLevelAsNumber(minimumLogLevel) <= this.logLevelAsNumber(logLevel);
    }
    logLevelAsNumber(logLevel) {
        switch (logLevel) {
            case LogEntry_1.LogLevel.debug:
                return 1;
            case LogEntry_1.LogLevel.info:
                return 2;
            case LogEntry_1.LogLevel.warn:
                return 3;
            case LogEntry_1.LogLevel.error:
                return 4;
            default:
                return 0;
        }
    }
}
exports.Logger = Logger;
function log(level, namespace, message, logObject) {
    const metadata = { levelName: level, namespace: namespace, message: message };
    if (engineId) {
        metadata.engineId = engineId;
    }
    if (hostname) {
        metadata.hostname = hostname;
    }
    const objectToLog = Object.assign(metadata, logObject);
    switch (level) {
        case LogEntry_1.LogLevel.error:
            logger.error(objectToLog);
            break;
        case LogEntry_1.LogLevel.warn:
            logger.warn(objectToLog);
            break;
        case LogEntry_1.LogLevel.info:
            logger.info(objectToLog);
            break;
        case LogEntry_1.LogLevel.debug:
            logger.debug(objectToLog);
            break;
    }
}
//# sourceMappingURL=Logger.js.map